// extracted by mini-css-extract-plugin
export const pageHeader = "Database-module--pageHeader--3mFtK";
export const cover = "Database-module--cover--2A8uC";
export const description = "Database-module--description--3d8Qz";
export const sortOptions = "Database-module--sortOptions--1XbfI";
export const active = "Database-module--active--3mUUn";
export const info = "Database-module--info--3pxK4";
export const play = "Database-module--play--26UcY";
export const build = "Database-module--build--3X7li";
export const grid = "Database-module--grid--1weiw";